<template>
  <div class="container page">
    <van-nav-bar class="nav-bar" :title="$t('任务详情')">
      <template #left>
        <van-icon color="#fff" name="arrow-left" @click="$router.back()"/>
      </template>
    </van-nav-bar>
    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="!gameInfo" :description="$t('数据为空') + '！'"/>
        <div v-else class="item_list">
          <div class="lottery_info">
            <van-image :src="BASE_URL + gameInfo.ico" class="cover">
              <template v-slot:loading>
                <van-loading type="spinner"/>
              </template>
            </van-image>
            <div style="color: #DFBB9E;font-size: 13px" class="period-number">{{ gameInfo.name }}</div>
            <div class="period-number">{{ gameInfo.expect }}</div>
          </div>
          <div class="money-info">
            <div class="bet-money">
              <div>{{ gameInfo.money }}</div>
              <div>{{ $t('下注金额') }}</div>
            </div>
            <div class="get-money">
              <div>{{ result }}</div>
              <div>{{ $t('获得金额') }}</div>
            </div>
          </div>
          <div class="bet-content">
            <div class="recent">
              <div class="kuaisan-ball left">
                <!--<van-image-->
                <!--    :src=" gameInfo.status === 0 ? 'img/lottery/open_num.gif' : 'img/lottery/shaizi/' + gameInfo.opencode[0] + '.png' "-->
                <!--    class="res-img">-->
                <!--  <template v-slot:loading>-->
                <!--    <van-loading type="spinner"/>-->
                <!--  </template>-->
                <!--</van-image>-->
                <!--<van-image-->
                <!--    :src=" gameInfo.status === 0 ? 'img/lottery/open_num.gif' : 'img/lottery/shaizi/' + gameInfo.opencode[1] + '.png' "-->
                <!--    class="res-img">-->
                <!--  <template v-slot:loading>-->
                <!--    <van-loading type="spinner"/>-->
                <!--  </template>-->
                <!--</van-image>-->
                <!--<van-image-->
                <!--    :src=" gameInfo.status === 0 ? 'img/lottery/open_num.gif' : 'img/lottery/shaizi/' + gameInfo.opencode[2] + '.png' "-->
                <!--    class="res-img">-->
                <!--  <template v-slot:loading>-->
                <!--    <van-loading type="spinner"/>-->
                <!--  </template>-->
                <!--</van-image>-->
                <span class="bet-result">{{ $t('投票结果') }}：</span>
                <span
                    class="res-des middle sum">{{
                    gameInfo.status === 0 ? 0 : gameInfo.opencode[0] + gameInfo.opencode[1] + gameInfo.opencode[2]
                  }}</span>
                <span
                    class="res-des middle option">{{
                    gameInfo.status === 0 ? 0 : (gameInfo.opencode[0] + gameInfo.opencode[1] + gameInfo.opencode[2]) >= 11 && (gameInfo.opencode[0] + gameInfo.opencode[1] + gameInfo.opencode[2]) &lt;= 18 ? bigSelectionText : smallSelectionText
                  }}</span>
                <span
                    class="res-des middle option">{{
                    gameInfo.status === 0 ? 0 : (gameInfo.opencode[0] + gameInfo.opencode[1] + gameInfo.opencode[2]) % 2 === 0 ? doubleSelectionText : oddSelectionText
                  }}</span>
              </div>
            </div>
            <div class="topInfo">
              <span style="color: #07c160">{{ gameInfo.status_text }}</span>
              <span>{{ gameInfo.status_text }}</span>
            </div>
            <div class="time">
              <span>{{ $t('下单时间') }}：{{ gameInfo.create_time }}</span>
            </div>
            <div class="time">
              <span>{{ $t('结算时间') }}：{{ gameInfo.update_time }}</span>
            </div>
            <div class="time">
              <span>{{ $t('投票方向') }}：</span>
              <div
                  class="bet-direction"
                  v-for="(select, index) in gameInfo.data"
                  :key="index"
              >
                <span
                    class="option bet-name"
                >
                  {{ optionToText(select.type) }}&nbsp;&nbsp;
                </span>
                <div class="bet-money-info">
                  <span class="bet-tip">{{ $t('投注') }}: </span>
                  <span class="bet-money-num">{{ select.money }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="one-more" @click="gotoLottery">{{ $t('再来一次') }}</div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      gameInfo: null,
      lottery_peilv_list: [],
      BASE_URL: process.env.VUE_APP_BASE_URL,
      result: 0
    };
  },
  computed: {
    bigSelectionText() {
      if (!this.lottery_peilv_list.length && this.gameInfo) {
        return ''
      }
      return this.lottery_peilv_list.find(item => item.type === '大').name
    },
    smallSelectionText() {
      if (!this.lottery_peilv_list.length && this.gameInfo) {
        return ''
      }
      return this.lottery_peilv_list.find(item => item.type === '小').name
    },
    oddSelectionText() {
      if (!this.lottery_peilv_list.length && this.gameInfo) {
        return ''
      }
      return this.lottery_peilv_list.find(item => item.type === '单').name
    },
    doubleSelectionText() {
      if (!this.lottery_peilv_list.length && this.gameInfo) {
        return ''
      }
      return this.lottery_peilv_list.find(item => item.type === '双').name
    },
  },
  filters: {},
  methods: {
    optionToText(option) {
      if (option === '大') {
        return this.bigSelectionText
      }
      if (option === '小') {
        return this.smallSelectionText
      }

      if (option === '单') {
        return this.oddSelectionText
      }
      if (option === '双') {
        return this.doubleSelectionText
      }
    },
    gotoLottery() {
      const {key, id} = this.gameInfo.data[0].lottery
      this.$router.push({path: `/Lottery?key=${key}&id=${id}`})
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("刷新成功") + '！');
        this.getUserGameList();
        this.isLoading = false;
      }, 500);
    },
    getLotteryPeilv(id) {
      return new Promise((resolve) => {
        this.$http({
          method: 'get',
          data: {id},
          url: 'lottery_get_peilv'
        }).then(res => {
          if (res.code === 200) {
            resolve(res.data);
            this.lottery_peilv_list = res.data
            console.log("=>(GameRecord.vue:124) res.data", res.data);
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
        })
      })
    },

    getUserGameList() {
      this.$toast.loading({message: this.$t('Loading...'), duration: 0})
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res => {
        if (res.code === 200) {
          console.log(res.data)
          res.data.forEach(item => {
            if (item.id === this.gameInfo.id) {
              this.gameInfo = item
              let result = 0;
              this.gameInfo.data.map(item => {
                if (item.win_text === '盈利') {
                  result += Number(item.profit);
                } else {
                  result -= Number(item.profit);
                }
              });
              this.result = result;
            }
          })
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
          .finally(() => {
            this.$toast.clear();
          })
    },

    async getGameInfo() {
      this.$toast.loading({message: this.$t('Loading...'), duration: 0})

      this.gameInfo = JSON.parse(window.localStorage.getItem('gameInfo'))
      console.log("=>(GameDetail.vue:115) this.gameInfo", this.gameInfo);
      await this.getLotteryPeilv(this.gameInfo.data[0].lid)
      let result = 0 - this.gameInfo.money;

      // 循环GameInfo.data，如果win_text === 盈利，在总金额result上加上当前循环的profit，否则就在result上减去当前循环的profit

      this.gameInfo.data.map(item => {
        if (item.win_text === '盈利') {
          result += parseFloat(Number(item.profit).toFixed(2));
        }
      });
      this.result = result.toFixed(2);
      this.$toast.clear();
    }
  },
  created() {
    this.getGameInfo();
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-pull-refresh {
  height: 100%;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main {
  position: relative;
  overflow: auto;
  background-color: #fff;
  min-height: 100%;
  padding: 0 10px;
}

.item_list {
  padding: 15px 15px;
  margin: 30px 10px;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span {
  flex: 1;
  font-size: 35px;
  font-weight: 700;
  color: #ff253f;
}

.item_list .time span {
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}

.item_list .bet-result {
  font-size: 25px;
  font-weight: 500;
  color: #000;
}

.bet-content {
  padding: 4px 20px 14px;
  background-color: #fff;
  border-radius: 10px;
}

.item_list .topInfo span:last-child {
  float: right;
}

.item_list .desc span {
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}

.item_list .cover {
  width: 100px;
  height: 100px;
  -o-object-fit: cover;
  border-radius: 10px;
  object-fit: cover;
}

.item_list .period-number {
  font-size: 35px;
  font-weight: 700;
  color: #000;
}

.item_list .lottery_info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #eee;
}

.recent {
  display: flex;
  align-items: center;
  height: 100px;
}

.kuaisan-ball .left {
  justify-content: flex-start;
}

.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img {
  width: 70px;
  height: 70px;
  margin-right: 30px;
}

.kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  color: #000;
}

.kuaisan-ball .res-des.middle {
  font-size: 35px;
}

.money-info {
  display: flex;
  margin: 16px 0;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
  justify-content: center;
  align-items: center;
}

.money-info > div {
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  color: #000000;
  font-weight: 700;
}

.sum {
  width: 52px !important;
  height: 52px !important;
  text-align: center;
  line-height: 52px;
  color: #fff !important;
  border-radius: 50%;
  background-color: #eaa07b;
  margin-right: 10px;
}

.option {
  font-weight: 700;
  text-align: center;
  background: linear-gradient(90deg, #7e5678, #e6c3a1);
  color: #fff !important;
  padding: 0 10px;
  height: 7vw;
  line-height: 7vw;
  font-size: 3vw;
  margin-right: 1vw;
  border-radius: 10px;
}

.period-number {
  flex: 1;
  margin-left: 20px;
  margin-right: 10px;
  font-size: 35px;
  color: #fff;
  font-weight: bold
}

.one-more {
  padding: 0 30px;
  margin: 0 80px;
  text-align: center;
  color: #fff;
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
  font-size: 28px;
  font-weight: 500;
  height: 70px;
  line-height: 70px;
  border-radius: 50px;
}

.bet-direction {
  border-radius: 10px;
  border: 1px solid #cccccc;
  padding: 12px 12px 10px 12px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  .bet-name {
    padding: 6px 10px;
    height: 100%;
    flex: 0 !important;
    display: flex;
    align-items: center;
    border-radius: 20px;
  }

  .bet-money-info {
    height: 100%;

    .bet-tip {
      color: #666;
      padding: 10px;
      font-size: 22px;
    }

    .bet-money-num {
      font-size: 32px;
      font-weight: bold;
    }

  }
}
</style>
